import apiClient from './api_client_requests';

export default async payload => {
    let result = await apiClient.apiMethod({
        method: 'ValidateTicket',
        args: {
            ...payload,
        },
    });

    if (result.entry) {
        return {
            entry: result.entry,
            success: true,
            message:
                'Your entry has been accepted and added to the list at the bottom of this page.',
        };
    } else if (result.response) {
        return {
            success: false,
            message: result.response.message,
        };
    } else {
        return {
            success: false,
            message: 'An Unspecified Error Occurred.',
        };
    }
};
